import { forwardRef, memo } from 'react';
import { Switch as MUISwitch } from '@mui/material';
import Grid from '../../Grid';
import {
  AG2, AO3, S1, S3, S4,
} from '../../../theme';
import { ISwitchProps } from '..';
import { mergeSX } from '../../../services/helpers';

interface IBuildSXParams {
  pending: boolean;
}

const buildSX = ({ pending }: IBuildSXParams) => ({
  padding: 0,
  display: 'flex',
  '&.MuiSwitch-sizeSmall': {
    width: '34px',
    height: '16px',
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: '12px',
      height: '12px',
    },
    '& .MuiSwitch-switchBase': {
      padding: '2px',
      '&.Mui-checked': {
        transform: 'translateX(18px)',
      },
    },
  },
  '&.MuiSwitch-sizeMedium': {
    width: '68px',
    height: '30px',
    '& .MuiSwitch-thumb': {
      boxShadow: 'none',
      width: '22px',
      height: '22px',
    },
    '& .MuiSwitch-switchBase': {
      padding: '4px',
      '&.Mui-checked': {
        transform: 'translateX(38px)',
      },
    },
  },
  '& .MuiSwitch-switchBase': {
    '&.Mui-checked': {
      color: S1,
      '&+.MuiSwitch-track': {
        opacity: 1,
        backgroundColor: pending ? AO3 : AG2,
      },
      '&.Mui-disabled': {
        color: S1,
        '&+.MuiSwitch-track': {
          opacity: pending ? 1 : 0.6,
          backgroundColor: pending ? AO3 : AG2,
          cursor: 'not-allowed',
        },
      },
    },
    '&.Mui-disabled': {
      color: S1,
      '&+.MuiSwitch-track': {
        opacity: 1,
        cursor: 'not-allowed',
        backgroundColor: S3,
      },
    },
  },
  '& .MuiSwitch-track': {
    borderRadius: '48px',
    opacity: 1,
    backgroundColor: S4,
  },
});

const Switch = forwardRef((props: ISwitchProps, ref) => {
  const {
    pending = false, size = 'small', label = null, sx, ...rest
  } = props;

  return (
    <Grid container alignItems="center">
      <MUISwitch
        size={size}
        inputRef={ref}
        sx={mergeSX(buildSX({ pending }), sx)}
        {...rest}
      />
      {label}
    </Grid>
  );
});

export default memo(Switch);
